<template>
  <div>
    <v-app>
      <div>
        <merchant-detail v-model="pageProfile"></merchant-detail>
        <v-container class="mt-5">
          <template v-if="pageLoading">
            <div class="text-xs-center my-3">
              <v-progress-circular
                :key="theme.color"
                indeterminate
                :color="theme.color"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <!-- {{ order }} -->

            <div class="text-xs-center">
              <img
                src="@/assets/img/ecommerce/success.png"
                style="max-width: 150px"
              />

              <div class="mb-4">
                <div
                  class="headline"
                  :class="{
                    'success--text': true
                  }"
                >
                  {{ $t('Payment Successfully') }}
                </div>
              </div>
            </div>
            <table class="mx-auto" style="width: 100%; max-width: 300px">
              <tr v-if="order_no">
                <td class="font-weight-bold py-1">Order No</td>
                <td class="text-xs-right py-1">
                  {{ order_no }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">Reference No</td>
                <td class="text-xs-right py-1">
                  {{ refNo }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">{{ $t('grand_total') }}</td>
                <td class="text-xs-right py-1">
                  {{ amount || 0 | decimalFormat }}
                </td>
              </tr>
            </table>
          </template>
        </v-container>
      </div>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
//https://shopv2.zwiz.ai/paysolution-return-url?userid=1421782574607927&pageid=998122266996445&referenceNo=778837624
export default {
  data() {
    return {
      userid: null,
      sessiontoken: null,
      order_no: null,
      refNo: null,
      amount: null,
      pageLoading: true
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),

    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    }
  },
  components: {
    MerchantDetail
  },
  async mounted() {
    const vm = this
    vm.$validator.localize(vm.currentLang)

    vm.loading = true

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }
    await vm.$store.dispatch('loadPageProfile', { pagename: vm.pagename })

    vm.pageLoading = true

    vm.pageid = vm.pageProfile.pageid

    document.title = vm.pageProfile.pagename
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    if (vm.$route.query.referenceNo) {
      vm.refNo = vm.$route.query.referenceNo
    }
    if (vm.$route.query.amount) {
      vm.amount = vm.$route.query.amount
    }
    if (vm.$route.query.order_no) {
      vm.order_no = vm.$route.query.order_no
    }

    vm.pageLoading = false
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>
